import { render, staticRenderFns } from "./AccountAuditTrail.vue?vue&type=template&id=20a9d3c2&"
import script from "./AccountAuditTrail.vue?vue&type=script&lang=js&"
export * from "./AccountAuditTrail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports